<template>
	<v-dialog
		v-model="showDialog"
		max-width="300px"
		:fullscreen="$vuetify.breakpoint.xs ? true : false"
		:transition="$vuetify.breakpoint.xs ? 'scroll-y-reverse-transition' : ''"
	>
		<v-card>
			<v-toolbar dark color="primary" dense flat>
				<v-toolbar-title style="color: white">追加部品の選択</v-toolbar-title>
				<v-spacer />
				<v-btn icon dark @click="showDialog = false" color="white">
					<v-icon>mdi-close</v-icon>
				</v-btn>
			</v-toolbar>
			<div class="table-container pa-2 mt-4">
				<v-data-table
					locale="ja-JP"
					:headers="headers"
					:items="order_components"
					:mobile-breakpoint="240"
					hide-default-footer
					disable-filtering
					disable-pagination
					disable-sort
					no-data-text="データがありません。"
				>
					<template v-slot:item="{ item }">
						<tr v-if="item.component" @click="addOrderComponent(item)">
							<td>{{ item.component.name }}</td>
						</tr>
						<tr v-else @click="addOrderComponent(item)">
							<td>{{ item.component_name }}</td>
						</tr>
					</template>
				</v-data-table>
			</div>
		</v-card>
	</v-dialog>
</template>

<script>
export default {
	props: {
		dialog: {
			type: Boolean,
			default: false,
		},
		order_components: {
			type: Array,
			default: () => [],
		},
	},

	data() {
		return {
			valid: false,
			errors: [],
			headers: [{ text: "部品名", value: "product_name", width: "200px", divider: true }],
		}
	},
	methods: {
		addOrderComponent(orderComponent) {
			const order_component = _.cloneDeep(orderComponent)
			this.$emit("add-component", order_component)
			this.showDialog = false
		},
	},

	computed: {
		showDialog: {
			get() {
				return this.dialog
			},
			set(newVal) {
				return this.$emit("update:dialog", newVal)
			},
		},
	},
}
</script>
